require('./bootstrap.js')

// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import App from "./App";
import router from "./router";
// Vuex router sync
import {
  sync
} from 'vuex-router-sync'
// Store
import store from './store/store.js';
import c from "Vue/Core/constants.js";
const unsync = sync(store, router) // done. Returns an unsync callback fn
Vue.config.productionTip = false;

import { startSignalRConnection } from '../static/Js/Signalr-Scripts/signalR.js'

startSignalRConnection()

// Global mixin for authorization related computed properties
Vue.mixin({
  computed: {
    isConsultant() {
      // return this.loggedInUserObj.Role == this.loggedInUserObj.Roles.Consultant
      return true
    },
    isRecruiter() {
      // return this.loggedInUserObj.Role == this.loggedInUserObj.Roles.Recruiter
      return false
    },
    isAccountManager() {
      // return this.loggedInUserObj.Role == this.loggedInUserObj.Roles.AccountManager
      return false
    },
    isAdmin() {
      // return this.loggedInUserObj.Role == this.loggedInUserObj.Roles.Admin
      return false
    },
    isHRManager() {
      // return this.loggedInUserObj.Role == this.loggedInUserObj.Roles.HRManager
      return false
    },
    loggedInUserObj() {
      // return JSON.parse(localStorage.getItem('user-details'))
      return window.loggedInUserObj
    },
    CDNIMAGESBASEURL(){
      return c.CDNIMAGESBASEURL
    }
  },

  methods: {
    // Returns whether the given variable is NULL or Empty string
    IsNullOrEmpty(value) {
      if (value && value.toString() != '') {
        return false
      } else {
        return true
      }
    },
    // Returns 'N/A' if the object doesn't have the key or the key is Null or Empty
    NAOrValue(obj, key) {
      if (obj && !this.IsNullOrEmpty(obj[key])) {
        return obj[key]
      }

      return 'N/A'
    },

    // Check the API response state and break the code if there is an error and
    // display it
    VerifyAPIResponse(res) {
      if (res.data.State === false) {
        this.$message({
          type: 'error',
          message: res.data.Message
        })

        return null
      }
    },
    ESSEnableDisable(res){
      if(!res.data.State){
        if(res.data.HasRestriction){
          if(res.data.Message == 'Login'){
            localStorage.removeItem("access_token")
            localStorage.removeItem("user_details")
            localStorage.setItem('isESSDisabled',true)
           // this.$router.push({'name': 'LoginPage'})
            window.location.href = c.WSO2LOGOUTURL;
          }
          else if(res.data.Message == 'SelectOrganization'){
            this.$router.push({'name':'SelectOrganization'})
          }
          else if(res.data.Message == 'Employee pages'){
            this.$loading({ 'loadingText': 'Loading...' })
            ajax.get(`/Employee/GetEmployeeDetails?orgId=${loggedInUserObj.orgId}`, {}, (res) => {
              var userObj = {}
              userObj.empId = res.data.EmpId
              userObj.name = res.data.EmployeeContact.FirstName + ' ' + res.data.EmployeeContact.LastName
              userObj.email = res.data.EmployeeContact.Email
              userObj.orgId = res.data.OrgId
              userObj.consultantId = res.data.ConsultantId
              userObj.profilepic = res.data.ProfilePicLink
              userObj.designation = res.data.Designation
              userObj.IsH1B = res.data.IsH1B
              userObj.OrgName = res.data.OrgName
              userObj.OrgWebSite = res.data.OrgWebsite
              userObj.HireType = res.data.HireType
              //userObj.SelectOrg = "multiple"
              // Update the employee details in local storage
              localStorage.setItem("user_details", JSON.stringify(userObj))
              window.userGuiding.identify('1Ax69i57j0j69i60l4', { email: userObj.email, name: userObj.name }) // or just send userId without attributes
             // window.userGuiding.identify(userObj.email)
              // update the employee details
              ajax.updateUserDetails()
              this.$router.push({'name':'ess-dashboard'})
              this.$loading({}).close()
            })
          }
        }

      }

    }
  }
})


/* eslint-disable no-new */
new Vue({
  el: "#app",
  //Added store to the main.js
  store,
  router,
  components: { App },
    template: "<App/>"
});



// WEBPACK FOOTER //
// ./src/main.js